import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../../../main/main.styles';
import { mixinRobotoBold, mixinRobotoMedium } from '../../../../styles';

export const MarketDepthGridStyles = css`
  ${MainStyles}
  .market-depth-component {
    width: 100%;
    gap: 12px;
    display: flex;
    flex-direction: column;
  }

  .grid-styles {
    width: 100%;
    height: 100%;
  }

  .no-criteria-wrapper {
    position: absolute;
    width: 100%;
    height: calc(100% - 83px);
    top: 83px;
    background-color: var(--neutral-layer-3);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .header {
    font-size: 15px;
    color: var(--gray-lighter);
    margin: 0;
    ${mixinRobotoBold}
  }

  .description {
    font-size: 13px;
    padding-top: 10px;
    color: var(--white-smoke);
    ${mixinRobotoMedium()}
  }
`;
